import type {
  AttachContractAttachmentMutationOptions,
  AttachContractAttachmentMutationVariables,
} from './types';

import { useMutation } from '@tanstack/react-query';

import { attachContractAttachment } from './attachContractAttachment';

/**
 * Custom hook for confirming a staged file upload and permanently attaching it to a contract.
 *
 * @param options - Additional options for the mutation.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/attach_attachment_contracts__contract_id__attachments_put
 */
export const useMutationAttachContractAttachment = (
  options?: AttachContractAttachmentMutationOptions,
) =>
  useMutation({
    mutationFn: async ({
      contractId,
      payload,
    }: AttachContractAttachmentMutationVariables) =>
      attachContractAttachment(contractId, payload),
    ...options,
  });
